import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export function validateForm(form) {
  let isValid = true;

  // Убираем все старые тултипы
  form.querySelectorAll('[data-tippy-root]').forEach(el => el._tippy?.destroy());

  form.querySelectorAll('input, textarea, select').forEach(input => {
    if (input.type === 'checkbox') {
      if (input.hasAttribute('required') && !input.checked) {
        showError(input, input.dataset.errorRequired || 'This field is required');
        isValid = false;
        return;
      }
    } else {
      const value = input.value.trim();

      if (input.hasAttribute('required') && !value) {
        showError(input, input.dataset.errorRequired || 'This field is required');
        isValid = false;
        return;
      }

      if (input.type === 'email' && value && !isValidEmail(value)) {
        showError(input, input.dataset.errorEmail || 'Invalid email address');
        isValid = false;
        return;
      }

      if (input.type === 'tel' && value && !isValidPhone(value)) {
        showError(input, input.dataset.errorPhone || 'Invalid phone number');
        isValid = false;
        return;
      }
    }
  });

  return isValid;
}

function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function isValidPhone(phone) {
  // Простейшая проверка на цифры и длину
  const cleaned = phone.replace(/\D/g, '');
  return cleaned.length >= 7 && cleaned.length <= 15;
}

function showError(input, message) {
  tippy(input, {
    content: message,
    placement: 'top',
    trigger: 'manual',
    hideOnClick: true,
    theme: 'custom',
  }).show();
}
